import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Scorecard from "./pages/Scorecard";
import KpiDetail from "./pages/KpiDetail";
import Anomalies from "./pages/Anomalies";
import Initiatives from "./pages/Initiatives";
import DataEntry from "./pages/DataEntry";
import Upload from "./pages/Upload";
import Reports from "./pages/Reports";
import Audit from "./pages/Audit";
import Benchmarks from "./pages/Benchmarks";
import EvidenceManager from "./pages/EvidenceManager";
import AdminShell from "./pages/admin/AdminShell";
import OrgSettings from "./pages/admin/OrgSettings";
import DatabaseManager from "./pages/admin/DatabaseManager";
import UnitsConversion from "./pages/admin/UnitsConversion";
import FactorLibraries from "./pages/admin/FactorLibraries";
import AiUsageMonitor from "./pages/admin/AiUsageMonitor";
import InfraCostMonitor from "./pages/admin/InfraCostMonitor";
import Quotas from "./pages/admin/Quotas";
import Entities from "./pages/admin/Entities";
import KpiOwnership from "./pages/admin/KpiOwnership";
import IbpapConsolidated from "./pages/platform/IbpapConsolidated";
import TenantsHealth from "./pages/platform/TenantsHealth";
import TenantWizard from "./pages/platform/TenantWizard";

function Private({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="h-screen flex items-center justify-center text-ink-soft text-sm">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Private><Layout /></Private>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/scorecard" element={<Scorecard />} />
            <Route path="/kpi/:kpiId" element={<KpiDetail />} />
            <Route path="/anomalies" element={<Anomalies />} />
            <Route path="/initiatives" element={<Initiatives />} />
            <Route path="/benchmarks" element={<Benchmarks />} />
            <Route path="/evidence" element={<EvidenceManager />} />
            <Route path="/data-entry" element={<DataEntry />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/admin" element={<AdminShell />}>
              <Route index element={<OrgSettings />} />
              <Route path="organisation" element={<OrgSettings />} />
              <Route path="database" element={<DatabaseManager />} />
              <Route path="units" element={<UnitsConversion />} />
              <Route path="factors" element={<FactorLibraries />} />
              <Route path="ai-usage" element={<AiUsageMonitor />} />
              <Route path="infra" element={<InfraCostMonitor />} />
              <Route path="quotas" element={<Quotas />} />
              <Route path="entities" element={<Entities />} />
              <Route path="kpi-ownership" element={<KpiOwnership />} />
            </Route>
            <Route path="/platform/ibpap" element={<IbpapConsolidated />} />
            <Route path="/platform/health" element={<TenantsHealth />} />
            <Route path="/platform/new-tenant" element={<TenantWizard />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
